import { render, staticRenderFns } from "./ExportDataToExcel.vue?vue&type=template&id=36831990&"
import script from "./ExportDataToExcel.vue?vue&type=script&lang=js&"
export * from "./ExportDataToExcel.vue?vue&type=script&lang=js&"
import style0 from "./ExportDataToExcel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports